export default __webpack_public_path__ + "static/media/luz2.c873cc47.png";